import { useMemo } from 'react';

import { NavConfigFragment } from '@/components/ConfigsProvider/graphql/fragment/generated/NavConfig';

import { toCustomLinksSidebarSection, withCustomLinksSection } from '../../utils/customLinks';
import { toSidebarItems } from '../../utils/toSidebarItems';
import useCustomNavLinks from '../useCustomNavLinks';
import useUnifiedNav from '../useUnifiedNav';

// Unified sidebar items: the built-in nav plus the admin's custom links
function useUnifiedSidebarItems(previewNavConfig?: NavConfigFragment) {
  const { nav, isLoading } = useUnifiedNav();
  const { webTabs } = useCustomNavLinks(previewNavConfig);

  const sidebarItems = useMemo(
    () => withCustomLinksSection(toSidebarItems(nav), toCustomLinksSidebarSection(webTabs)),
    [nav, webTabs],
  );

  return { sidebarItems, isLoading };
}

export default useUnifiedSidebarItems;
